import { useRecordContext, FieldProps } from 'react-admin';
import { Typography } from '@mui/material';

export interface YenFieldProps extends FieldProps {
  source: string;
  label?: string;
}

const YenField = ({ source }: YenFieldProps) => {
  const record = useRecordContext();
  if (!record) return null;

  const value = record[source];
  const formatted = new Intl.NumberFormat('ja-JP').format(value);

  return (
    <Typography variant="body2" component="span">
      {formatted} 円
    </Typography>
  );
};

export default YenField;
